import * as React from 'react';
import { Grid, SearchBar, SearchContext } from '@giphy/react-components';
import { IGif } from '@giphy/js-types';

const GIPHY_ATTRIBUTION_LABEL = 'Powered by GIPHY';

interface IGifPickerContentProps {
    onSelect: (gif: IGif) => void;
    searchPlaceholder: string;
    width: number;
    columns: number;
}

export const GifPickerContent: React.FunctionComponent<IGifPickerContentProps> = ({
    onSelect,
    searchPlaceholder,
    width,
    columns,
}) => {
    const { fetchGifs, searchKey } = React.useContext(SearchContext);

    return (
        <div className="gif-picker__content">
            <SearchBar placeholder={searchPlaceholder} autoFocus={true} />
            <div className="gif-picker__grid-wrapper">
                <Grid
                    key={searchKey}
                    columns={columns}
                    width={width}
                    fetchGifs={fetchGifs}
                    onGifClick={(gif, e) => {
                        e.preventDefault();
                        onSelect(gif);
                    }}
                    noLink
                    hideAttribution
                />
            </div>
            <div className="gif-picker__attribution">{GIPHY_ATTRIBUTION_LABEL}</div>
        </div>
    );
};

export default GifPickerContent;
